// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7506":"e094a891","8040":"dbf96556","9576":"a7d429f7"}[chunkId] + ".chunk.css";
};